import {
  SET_PENDING,
  SET_TOUCHED,
  SET_DEALERSHIPS,
  FORGET_DEALERSHIPS,
} from "./types";

const INITIAL_STATE = {
  all: [],
  ref: {},
  pending: true,
  touched: false,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_PENDING:
      return { ...state, pending: payload };
    case SET_TOUCHED:
      return { ...state, touched: payload };
    case SET_DEALERSHIPS:
      return { ...state, ...payload };
    case FORGET_DEALERSHIPS:
      return { ...INITIAL_STATE };
    default:
      return state;
  }
};
